import { FORMAT_TYPE } from "../../../data/variables";
import i18n from "../../../i18n";

export enum REPORTCOLS {
  REGISTRY_NUMBER = 'REGISTRY_NUMBER',
  GLOBALID = 'GLOBALID',
  MOBILE_DESCR = 'MOBILE_DESCR',
  ODOMETER = 'ODOMETER',
  WORKING_HOURS = 'WORKING_HOURS',
  DRIVER = 'DRIVER',
  VEHICLE = 'VEHICLE',
  CREATE_DATE = 'CREATE_DATE',
  FILE_TYPE = 'FILE_TYPE',
  FILE = 'FILE',
  TIME = 'TIME',
  LOCATION = 'LOCATION',
  RADIUS = 'RADIUS',
  SIGNAL_STRENGTH = 'SIGNAL_STRENGTH',
  DATE = 'DATE',
  STARTED_WORKING = 'STARTED_WORKING',
  STOPPED_WORKING = 'STOPPED_WORKING',
  DISTANCE = 'DISTANCE',
  TOTAL_STOP_TIME = 'TOTAL_STOP_TIME',
  TOTAL_IDLE_TIME = 'TOTAL_IDLE_TIME',
  DRIVING_TIME = 'DRIVING_TIME',
  MAX_SPEED_OVER_LIMIT = 'MAX_SPEED_OVER_LIMIT',
  RESPONSIBLE = 'RESPONSIBLE',
  SPEEDING = 'SPEEDING',
  TRANSACTION_ID = 'TRANSACTION_ID',
  PURCHASE_DATE = 'PURCHASE_DATE',
  SITE_NAME = 'SITE_NAME',
  VOLUME = 'VOLUME',
  AVERAGE_FUEL_CONSUMPTION = 'AVERAGE_FUEL_CONSUMPTION',
  DEVIATION_RECORDED = 'DEVIATION_RECORDED',
  FUEL_TYPE = 'FUEL_TYPE',
  TOTAL_EMISSIONS = 'TOTAL_EMISSIONS',
  TOTAL_DISTANCE = 'TOTAL_DISTANCE',
  DATE_FROM = 'DATE_FROM',
  DATE_TO = 'DATE_TO',
  DURATION = 'DURATION',
  AREA = 'AREA',
  SPEEDLIMIT = 'SPEEDLIMIT',
  SPEED = 'SPEED',
  SERVICE = 'SERVICE',
  SERVICE_TYPE = 'SERVICE_TYPE',
  DESCRIPTION = 'DESCRIPTION',
  PLANNED_AT = 'PLANNED_AT',
  SERVICED_AT = 'SERVICED_AT',
  COST = 'COST',
  MESSAGE = 'MESSAGE',
  COMMENT = 'COMMENT',
  CHECKED_FROM = 'CHECKED_FROM',
  CHECKED_TO = 'CHECKED_TO',
  APPROVED = 'APPROVED',
  USER = 'USER',
  NAME = 'NAME',
  LAST_MODIFIED = 'LAST_MODIFIED',
  STOP_COUNT = 'STOP_COUNT',
  AVG_IDLE_DURATION = 'AVG_IDLE_DURATION',
  PERIOD = 'PERIOD',
  TOTAL_HOURS = 'TOTAL_HOURS',
  TOTAL = 'TOTAL',
  PERIOD_DISTANCE = 'PERIOD_DISTANCE',
  EMISSIONS_GKM = 'EMISSIONS_GKM',
}

export const REP_COLS = {
  [REPORTCOLS.REGISTRY_NUMBER]: {
    id: REPORTCOLS.REGISTRY_NUMBER,
    label: i18n.t('Registry number'),
    path: 'registration_number',
    type: FORMAT_TYPE.STRING,
  },
  [REPORTCOLS.GLOBALID]: {
    id: REPORTCOLS.GLOBALID,
    label: i18n.t('Global ID'),
    path: 'globalid',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.MOBILE_DESCR]: {
    id: REPORTCOLS.MOBILE_DESCR,
    label: i18n.t('Description'),
    path: 'description',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.ODOMETER]: {
    id: REPORTCOLS.ODOMETER,
    label: i18n.t('Odometer'),
    path: 'odometer',
    type: FORMAT_TYPE.KILOMETERS
  },
  [REPORTCOLS.WORKING_HOURS]: {
    id: REPORTCOLS.WORKING_HOURS,
    label: i18n.t('Working hours'),
    path: 'working_hours',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.DRIVER]: {
    id: REPORTCOLS.DRIVER,
    label: i18n.t('Driver'),
    path: 'driver',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.VEHICLE]: {
    id: REPORTCOLS.VEHICLE,
    label: i18n.t('Mobile'),
    path: 'globalid',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.CREATE_DATE]: {
    id: REPORTCOLS.CREATE_DATE,
    label: i18n.t('Created'),
    path: 'uploaded',
    type: FORMAT_TYPE.DATETIME
  },
  [REPORTCOLS.FILE_TYPE]: {
    id: REPORTCOLS.FILE_TYPE,
    label: i18n.t('Type'),
    path: 'type',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.FILE]: {
    id: REPORTCOLS.FILE,
    label: i18n.t('File'),
    path: 'file_name',
    type: FORMAT_TYPE.FILE
  },
  [REPORTCOLS.TIME]: {
    id: REPORTCOLS.TIME,
    label: i18n.t('Time'),
    path: 'posdate',
    type: FORMAT_TYPE.DATETIME
  },
  [REPORTCOLS.LOCATION]: {
    id: REPORTCOLS.LOCATION,
    label: i18n.t('Location'),
    path: 'location',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.RADIUS]: {
    id: REPORTCOLS.RADIUS,
    label: i18n.t('Radius'),
    path: 'est_radius',
    type: FORMAT_TYPE.METERS
  },
  [REPORTCOLS.SIGNAL_STRENGTH]: {
    id: REPORTCOLS.SIGNAL_STRENGTH,
    label: i18n.t('Signal strength'),
    path: 'signal_strength',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.DATE]: {
    id: REPORTCOLS.DATE,
    label: i18n.t('Date'),
    path: 'date',
    type: FORMAT_TYPE.DATE
  },
  [REPORTCOLS.STARTED_WORKING]: {
    id: REPORTCOLS.STARTED_WORKING,
    label: i18n.t('Started working'),
    path: 'started_working',
    type: FORMAT_TYPE.TIME
  },
  [REPORTCOLS.STOPPED_WORKING]: {
    id: REPORTCOLS.STOPPED_WORKING,
    label: i18n.t('Stopped working'),
    path: 'stopped_working',
    type: FORMAT_TYPE.TIME
  },
  [REPORTCOLS.DISTANCE]: {
    id: REPORTCOLS.DISTANCE,
    label: i18n.t('Distance'),
    path: 'distance',
    type: FORMAT_TYPE.DISTANCE
  },
  [REPORTCOLS.TOTAL_STOP_TIME]: {
    id: REPORTCOLS.TOTAL_STOP_TIME,
    label: i18n.t('Total stop time'),
    path: 'total_stop_time',
    type: FORMAT_TYPE.HOURS
  },
  [REPORTCOLS.TOTAL_IDLE_TIME]: {
    id: REPORTCOLS.TOTAL_IDLE_TIME,
    label: i18n.t('Total idle time'),
    path: 'total_idle_time',
    type: FORMAT_TYPE.HOURS
  },
  [REPORTCOLS.DRIVING_TIME]: {
    id: REPORTCOLS.DRIVING_TIME,
    label: i18n.t('Driving time'),
    path: 'driving_time',
    type: FORMAT_TYPE.HOURS
  },
  [REPORTCOLS.MAX_SPEED_OVER_LIMIT]: {
    id: REPORTCOLS.MAX_SPEED_OVER_LIMIT,
    label: i18n.t('Max speed over limit'),
    path: 'max_speed_over_limit',
    type: FORMAT_TYPE.SPEED
  },
  [REPORTCOLS.RESPONSIBLE]: {
    id: REPORTCOLS.RESPONSIBLE,
    label: i18n.t('Responsible'),
    path: 'responsible',
    type: undefined
  },
  [REPORTCOLS.SPEEDING]: {
    id: REPORTCOLS.SPEEDING,
    label: i18n.t('Speeding'),
    path: 'speeding',
    type: undefined
  },
  [REPORTCOLS.TRANSACTION_ID]: {
    id: REPORTCOLS.TRANSACTION_ID,
    label: i18n.t('Transaction id'),
    path: 'transactionid',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.PURCHASE_DATE]: {
    id: REPORTCOLS.PURCHASE_DATE,
    label: i18n.t('Date'),
    path: 'purchasedate',
    type: FORMAT_TYPE.DATETIME
  },
  [REPORTCOLS.SITE_NAME]: {
    id: REPORTCOLS.SITE_NAME,
    label: i18n.t('Site name'),
    path: 'sitename',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.VOLUME]: {
    id: REPORTCOLS.VOLUME,
    label: i18n.t('Volume (L)'),
    path: 'quantity',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.AVERAGE_FUEL_CONSUMPTION]: {
    id: REPORTCOLS.AVERAGE_FUEL_CONSUMPTION,
    label: i18n.t('Average fuel consumption'),
    path: 'average_fuel_consumption',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.DEVIATION_RECORDED]: {
    id: REPORTCOLS.DEVIATION_RECORDED,
    label: i18n.t('Deviation recorded'),
    path: 'pump_distance',
    type: undefined
  },
  [REPORTCOLS.FUEL_TYPE]: {
    id: REPORTCOLS.FUEL_TYPE,
    label: i18n.t('Type'),
    path: 'fuel_type_name',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.TOTAL_DISTANCE]: {
    id: REPORTCOLS.TOTAL_DISTANCE,
    label: i18n.t('Distance'),
    path: 'total_odometer',
    type: FORMAT_TYPE.KILOMETERS
  },
  [REPORTCOLS.TOTAL_EMISSIONS]: {
    id: REPORTCOLS.TOTAL_EMISSIONS,
    label: i18n.t('Emissions'),
    path: 'total_emission',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.DATE_FROM]: {
    id: REPORTCOLS.DATE_FROM,
    label: i18n.t('From'),
    path: 'posdate_in',
    type: FORMAT_TYPE.DATETIME
  },
  [REPORTCOLS.DATE_TO]: {
    id: REPORTCOLS.DATE_TO,
    label: i18n.t('To'),
    path: 'posdate_out',
    type: FORMAT_TYPE.DATETIME
  },
  [REPORTCOLS.DURATION]: {
    id: REPORTCOLS.DURATION,
    label: i18n.t('Duration'),
    path: 'duration',
    type: FORMAT_TYPE.HOURS
  },
  [REPORTCOLS.AREA]: {
    id: REPORTCOLS.AREA,
    label: i18n.t('Location'),
    path: 'area',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.SPEEDLIMIT]: {
    id: REPORTCOLS.SPEEDLIMIT,
    label: i18n.t('Speedlimit'),
    path: 'speedlimit',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.SPEED]: {
    id: REPORTCOLS.SPEED,
    label: i18n.t('Speed'),
    path: 'speed',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.SERVICE]: {
    id: REPORTCOLS.SERVICE,
    label: i18n.t('Service'),
    path: 'title',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.SERVICE_TYPE]: {
    id: REPORTCOLS.SERVICE_TYPE,
    label: i18n.t('Service type'),
    path: 'service_type',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.DESCRIPTION]: {
    id: REPORTCOLS.DESCRIPTION,
    label: i18n.t('Description'),
    path: 'description',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.PLANNED_AT]: {
    id: REPORTCOLS.PLANNED_AT,
    label: i18n.t('Planned at'),
    path: 'planned_at',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.SERVICED_AT]: {
    id: REPORTCOLS.SERVICED_AT,
    label: i18n.t('Serviced at'),
    path: 'serviced_at',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.COST]: {
    id: REPORTCOLS.COST,
    label: i18n.t('Cost (kr)'),
    path: 'cost',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.MESSAGE]: {
    id: REPORTCOLS.MESSAGE,
    label: i18n.t('Message'),
    path: 'message',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.COMMENT]: {
    id: REPORTCOLS.COMMENT,
    label: i18n.t('Comment'),
    path: 'comment',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.NAME]: {
    id: REPORTCOLS.NAME,
    label: i18n.t('Mobile'),
    path: 'name',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.CHECKED_FROM]: {
    id: REPORTCOLS.CHECKED_FROM,
    label: i18n.t('From'),
    path: 'checked_from',
    type: FORMAT_TYPE.DATE
  },
  [REPORTCOLS.CHECKED_TO]: {
    id: REPORTCOLS.CHECKED_TO,
    label: i18n.t('To'),
    path: 'checked_to',
    type: FORMAT_TYPE.DATE
  },
  [REPORTCOLS.APPROVED]: {
    id: REPORTCOLS.APPROVED,
    label: i18n.t('Approved'),
    path: 'approved',
    type: FORMAT_TYPE.BOOLEAN
  },
  [REPORTCOLS.USER]: {
    id: REPORTCOLS.USER,
    label: i18n.t('User'),
    path: 'user',
    type: FORMAT_TYPE.STRING
  },
  [REPORTCOLS.LAST_MODIFIED]: {
    id: REPORTCOLS.LAST_MODIFIED,
    label: i18n.t('Last modified'),
    path: 'modified',
    type: FORMAT_TYPE.DATETIME
  },
  [REPORTCOLS.STOP_COUNT]: {
    id: REPORTCOLS.STOP_COUNT,
    label: i18n.t('Stop count'),
    path: 'stop_count',
    type: FORMAT_TYPE.NUMBER
  },
  [REPORTCOLS.AVG_IDLE_DURATION]: {
    id: REPORTCOLS.AVG_IDLE_DURATION,
    label: i18n.t('Avg. idle duration'),
    path: 'avg_idle_duration',
    type: FORMAT_TYPE.HOURS
  },
  [REPORTCOLS.PERIOD]: {
    id: REPORTCOLS.PERIOD,
    type: FORMAT_TYPE.HOURS,
    isDynamic: true
  },
  [REPORTCOLS.TOTAL_HOURS]: {
    id: REPORTCOLS.TOTAL_HOURS,
    label: i18n.t('Total hours'),
    path: 'absolute_total',
    type: FORMAT_TYPE.HOURS
  },
  [REPORTCOLS.TOTAL]: {
    id: REPORTCOLS.TOTAL,
    label: i18n.t('Total'),
    path: 'total_odometer',
    type: FORMAT_TYPE.KILOMETERS
  },
  [REPORTCOLS.PERIOD_DISTANCE]: {
    id: REPORTCOLS.PERIOD_DISTANCE,
    type: FORMAT_TYPE.KILOMETERS,
    isDynamic: true
  },
  [REPORTCOLS.EMISSIONS_GKM]: {
    id: REPORTCOLS.EMISSIONS_GKM,
    label: i18n.t('CO2 Emissions g/km'),
    path: 'emission_level',
    type: FORMAT_TYPE.NUMBER
  },
}